import { styled } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';

export const StyledTableContainer = styled(TableContainer)`
  max-height: 180px;
`;
